import React, { useEffect, useRef, useState } from 'react';
import { TextField, Button, IconButton, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { AddCircle, KeyboardArrowDown, KeyboardArrowUp, MoreVert } from '@material-ui/icons';
import { CSVLink } from 'react-csv';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropDown';
import ListFilterMenu from '../list-filter-menu/List-Filter-Menu';
import { SaveButton } from '../custom-dragdrop/Save-Button';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import './Search-bar.scss';
import { JSZip } from 'jszip';
import CustomPopupModel from '../custom-popup/Custom-Popup';
import ActionMenuList from '../ActionMenuList/ActionMenuList';
import MultipleSelectionAlert from '../MultiActionPopUp/MultipleSelectionAlert';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const SearchBar = (props) => {
  const {
    setSearchText,
    onOpenDrawer,
    buttonName,
    type,
    searchText,
    filterList,
    setFilterDataList,
    filteredRecoard,
    displayAddOrEdit,
    createDisabled,
    visible,
    setVisible,
    popUp,
    setPopUp,
    placeHolder,
    setPlaceHolder,
    globalPlaceHolder,
    setGlobalPlaceHolder,
    globalCategoryPlaceHolder,
    globalRoomTypePlaceHolder,
    dispatch,
    mappingApi,
    displayText,
    module,
    nestedStatus,
    setNestedStatus,
    setExpanded,
    setDrag,
    extraSecondaryBtnDisplay,
    extraSecondaryBtnText,
    onClickSecondaryBtn,
    exportBtn,
    exportBtnTitle,
    exportData,
    headers,
    isSortAvailable = false,
    onSortChannelNumber,
    setAnchorEl,
    anchorEl,
    actionMenuItems,
    handleAction,
    // totalSelectedFilters,
    deviceFilterCount,
    statusFilterCount,
    audienceFilterCount,
  } = props;
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const [addOrEditDisplay, setAddOrEditDisplay] = useState(false);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [searchButton, setSearchButton] = useState(true);
  const [isEmptyData, setIsEmptyData] = useState(false);
  const classes = useStyles();
  const searchRef = useRef(null);
  const filterRef = useRef(null);
  const [modalStyle] = useState(getModalStyle);
  const [isSortChannel, setIsSortChannel] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);

  useEffect(() => {
    setAddOrEditDisplay(displayAddOrEdit === 'show');
  }, [displayAddOrEdit]);

  useEffect(() => {
    setSearchButton(true);
  }, [globalPlaceHolder]);

  const handleFilter = (filterItems, field) => {
    if (filterItems) {
      const filteredRows = filterItems.filter((filterKey) => filterKey.selected);
      const updatedFilterMenu = [...filterList];
      updatedFilterMenu[updatedFilterMenu.findIndex((o) => o.field === field)].subMenu =
        filterItems;
      filteredRecoard(filteredRows, field);
      setFilterDataList(updatedFilterMenu);
    } else {
      filteredRecoard(null, field);
    }
  };

  const checkedPlaceHolderItems = placeHolder?.filter((rate) => rate?.isChecked);

  const handleFilterMenu = (event) => {
    if (checkedPlaceHolderItems?.length > 0) {
      setShowBulkFilterAlert(true);
      return;
    } else {
      setFilterTargetButton(event.currentTarget);
    }
  };

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const joiner = (data) => {
    const enclosingCharacter = '"';
    const separator = ',';
    return data
      ?.filter((e) => e)
      ?.map((row) =>
        row?.map((column) => `${enclosingCharacter}${column}${enclosingCharacter}`).join(separator),
      )
      .join(`\n`);
  };

  const onClickTvChannelExport = () => {
    if (exportData.length === 0) {
      setIsEmptyData(true);
    } else {
      let head = [headers?.map((x) => x.label)];
      let head2 = [
        [
          'Channel Name',
          'Channel Code',
          'Category Code',
          'Bouquet Code',
          'Channel No',
          'Channel Language',
          'Description',
          'TV Type',
          'External URL',
          'IP Address',
          'Port',
          'EPG URL',
          'Is a DRM',
          'Active',
        ],
      ];
      let row = [...exportData];
      let row2 = [...exportData];
      for (let item = 0; item < row?.length; ++item) {
        let temp = [
          row[item].name,
          row[item].code,
          row[item].categoryCode,
          row[item].bouquetCode,
          row[item].number,
          row[item].language,
          row[item].description,
          row[item].tvType,
          row[item].externalURL,
          row[item].channelType,
          row[item].frequency,
          row[item].broadCastStandard,
          row[item].modulationType,
          row[item].bandwidth,
          row[item].programNumber,
          row[item].majorNumber,
          row[item].satelliteId,
          row[item].polarization,
          row[item].epgURL,
          row[item].isDrm,
          row[item].active,
        ];
        if (row[item].frequency !== '') {
          head.push(temp);
        }
      }

      for (let item = 0; item < row2?.length; ++item) {
        let temp2 = [
          row2[item].name,
          row2[item].code,
          row2[item].categoryCode,
          row2[item].bouquetCode,
          row2[item].number,
          row2[item].language,
          row2[item].description,
          row2[item].tvType,
          row2[item].externalURL,
          row2[item].ip_address,
          row2[item].port,
          row2[item].epgURL,
          row2[item].isDrm,
          row2[item].active,
        ];

        if (row2[item].ip_address !== '') {
          head2.push(temp2);
        }
      }

      const csvRows = [];
      for (let cell = 0; cell < head.length; ++cell) {
        csvRows.push(head[cell]);
      }

      const csvRows2 = [];
      for (let cell = 0; cell < head2.length; ++cell) {
        csvRows2.push(head2[cell]);
      }

      let csvString = joiner(csvRows);
      let csvString2 = joiner(csvRows2);

      let coAxial = new Blob([csvString], { type: 'text/csv' });
      let iptv = new Blob([csvString2], { type: 'text/csv' });
      const zip = require('jszip')();
      zip.file('Coaxial Channels List' + '.csv', coAxial);
      zip.file('IPTV Channels List' + '.csv', iptv);
      zip
        .generateAsync({
          type: 'base64',
        })
        .then(function (content) {
          let link = document.createElement('a');
          link.href = 'data:application/zip;base64,' + content;
          link.download = 'TV_Channels_list.zip';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    }
  };

  const handleSearchInputFocus = (e) => {
    if (placeHolder?.filter((data) => data?.isChecked)?.length) {
      setShowBulkSearchAlert(true);
      searchRef?.current?.blur();
    } else {
      setShowBulkSearchAlert(false);
    }
  };

  const handleContinue = (isFromFilterContinue = false) => {
    setShowBulkSearchAlert(false);
    setPlaceHolder((prev) => prev.map((item) => ({ ...item, isChecked: false })));

    setTimeout(() => {
      if (isFromFilterContinue) {
        filterRef?.current?.click();
      } else {
        searchRef?.current?.focus();
      }
    }, 0);
  };

  const filterOpen = Boolean(filterTargetButton);
  const hasFilterSelected = filterList?.some((f) => f.subMenu?.some((s) => s.selected));

  useEffect(() => {
    if (typeof setDrag === 'function') {
      const enable = !searchText && !hasFilterSelected;
      setDrag(enable);
    }
  }, [searchText, hasFilterSelected, setDrag, visible]);

  return (
    <div className='col px-3 d-flex d-sm-block d-md-flex flex-wrap'>
      <div
        className='col-12 col-lg-4 pe-2'
        onClick={() => {
          if (visible) setPopUp(true);
        }}
      >
        <TextField
          className='w-100'
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setSearchButton(e?.target?.value ? false : true);
          }}
          onFocus={() => handleSearchInputFocus()}
          label='Search'
          focused={false}
          inputRef={searchRef}
          InputProps={{
            endAdornment: searchButton ? (
              <InputAdornment position='end'>
                <IconButton className='showpopup'>{<SearchIcon />}</IconButton>
              </InputAdornment>
            ) : (
              <></>
            ),
          }}
        />
      </div>
      <div className='col-12 col-lg-8 pt-3'>
        <div className='d-flex justify-content-end flex-wrap gap-2'>
          {actionMenuItems?.length !== 0 && (
            <div>
              <Button
                onClick={handleActionMenuOpen}
                variant='outlined'
                size='large'
                color='secondary'
                endIcon={
                  module === 'WELCOME_MESSAGE' ? (
                    filterOpen ? (
                      <KeyboardArrowUp />
                    ) : (
                      <KeyboardArrowDown />
                    )
                  ) : (
                    <ArrowDropDownIcon />
                  )
                }
                className={module === 'WELCOME_MESSAGE' ? 'dropdown-button' : 'showpopup'}
                style={
                  module === 'WELCOME_MESSAGE'
                    ? {
                        color: '#828282',
                        borderColor: '#828282',
                        marginRight: '50px',
                        marginLeft: '50px',
                      }
                    : undefined
                }
              >
                Actions
              </Button>
              <ActionMenuList
                anchorEl={actionMenuAnchorEl ?? null}
                handleClose={handleActionMenuClose}
                handleAction={handleAction}
                actionMenuItems={actionMenuItems}
              />
            </div>
          )}
          {isSortAvailable && (
            <Button
              onClick={() => setIsSortChannel(true)}
              variant='contained'
              color='secondary'
              className='text-nowrap'
              size='large'
            >
              Sort
            </Button>
          )}
          {!isSortAvailable && (
            <SaveButton
              {...{
                visible,
                setVisible,
                popUp,
                setPopUp,
                placeHolder,
                setPlaceHolder,
                globalPlaceHolder,
                setGlobalPlaceHolder,
                globalCategoryPlaceHolder,
                globalRoomTypePlaceHolder,
                dispatch,
                mappingApi,
                displayText,
                module,
                nestedStatus,
                setNestedStatus,
                setExpanded,
                setDrag,
              }}
            />
          )}
          {filterList && filterList.length > 0 && (
            <>
              <Button
                innerRef={filterRef}
                variant='outlined'
                color='secondary'
                size='large'
                endIcon={
                  module === 'WELCOME_MESSAGE' ? (
                    filterOpen ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    )
                  ) : (
                    <ArrowDropDownIcon />
                  )
                }
                onClick={(e) => {
                  handleFilterMenu(e);
                }}
                className={hasFilterSelected ? 'filterButton' : 'dropdown-button'}
              >
                Filter
              </Button>
              <ListFilterMenu
                menu={filterList}
                targetEl={filterTargetButton}
                handleFilterClose={() => setFilterTargetButton(null)}
                handleFilter={(items, field) => {
                  handleFilter(items, field);
                }}
                hideSearch={true}
                deviceFilterCount={deviceFilterCount}
                statusFilterCount={statusFilterCount}
                audienceFilterCount={audienceFilterCount}
                module='WELCOME_MESSAGE'
              />
            </>
          )}

          {exportBtn && module !== 'TV_CHANNEL' && (
            <Button variant='outlined' size='large' className='customize-btn'>
              <CSVLink
                style={{ color: '#828282', textDecoration: 'none' }}
                filename={`Elevate_${module.toLowerCase()}.csv`}
                headers={headers}
                data={exportData && exportData.length !== 0 ? exportData : []}
                onClick={() => {
                  if (exportData.length === 0) {
                    setIsEmptyData(true);
                    return false;
                  }
                }}
              >
                {exportBtnTitle}
                <span>
                  <img
                    className='mb-1 ms-2'
                    src={'./assets/icons/dashboard/export-icon.svg'}
                    alt={'completed'}
                  />
                </span>
              </CSVLink>
            </Button>
          )}
          {exportBtn && module === 'TV_CHANNEL' && (
            <Button
              variant='outlined'
              size='large'
              className='customize-btn'
              onClick={onClickTvChannelExport}
            >
              {exportBtnTitle}
              <span>
                <img
                  className='mb-1 ms-2'
                  src={'./assets/icons/dashboard/export-icon.svg'}
                  alt={'completed'}
                />
              </span>
            </Button>
          )}
          {extraSecondaryBtnDisplay && (
            <Button
              variant='outlined'
              size='large'
              onClick={(e) => {
                onClickSecondaryBtn(e);
              }}
              className='customize-btn showpopup'
            >
              {extraSecondaryBtnText}
              <span>
                <img
                  className='mb-1 ms-2'
                  src={'./assets/icons/dashboard/upload-icon.svg'}
                  alt={'completed'}
                />
              </span>
            </Button>
          )}
          {addOrEditDisplay && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, type);
              }}
              disabled={createDisabled}
              className='showpopup'
            >
              {buttonName}
            </Button>
          )}
        </div>
        {isEmptyData && (
          <Modal open={isEmptyData}>
            <div style={modalStyle} className={classes.paper}>
              <div className='custom-popup mt-4'>
                <div className='custom-popup-title'>There is no data to export</div>
                <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
                  <Button
                    variant='outlined'
                    size='large'
                    color='secondary'
                    onClick={() => setIsEmptyData(false)}
                  >
                    Ok
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        )}
        {isSortAvailable && (
          <CustomPopupModel
            popUp={{
              status: isSortChannel,
              title: 'Sort Channel Sequence?',
              description:
                'On click of "Sort" Channel numbers that are out of sequence or missing will be automatically arranged in ascending order.',
              buttonName: 'Yes',
              cancel: 'No',
            }}
            style={{
              paddingLeft: '2rem',
              paddingRight: '2rem',
            }}
            onClickCancel={() => setIsSortChannel(false)}
            onClick={() => {
              onSortChannelNumber();
              setIsSortChannel(false);
            }}
          />
        )}
        {showBulkFilterAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkFilterAlert}
            onClose={() => setShowBulkFilterAlert(false)}
            message="If you perform a filter after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onConfirm={() => {
              handleContinue(true);
            }}
          />
        )}{' '}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            message="If you perform a search after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onClose={() => setShowBulkSearchAlert(false)}
            onConfirm={handleContinue}
          />
        )}
      </div>
    </div>
  );
};

export default SearchBar;
